export default __webpack_public_path__ + "static/identity1c-d7fa0712084cd1ff3c8c13a4d02681cc.jpg";